import React from "react";

import './UnderConstruction.styles.css'
import underConstruction from '../../assets/underConstruction/underConstruction.jpg'
import { Container } from "react-bootstrap";
const UnderConstruction = () => {
    return ( 
        <Container className="p-0">
        <div style={{backgroundImage:`url(${underConstruction})`,backgroundSize:'cover'}} className='img-container'>
        <p className='text'>Under Construction</p>
      </div>
      </Container>
     );
}
 
export default UnderConstruction;